export default __webpack_public_path__ + "static/media/Directory.0eb22311.svg";